import moment from "moment/moment";
import FormItem from "~/components/_global/FormItem";
import React from "react";

export const timeColumns = ({ selectedSessions, handleSessionSelected, form }) => [
    {
        title: 'Time',
        dataIndex: 'startTime',
        key: 'time',
        render: (data, record) =>
            <span>{ moment(record.startTime).format("LT") } - { moment(record.endTime).format("LT") }</span>
    }, {
        title: 'Select',
        key: 'select',
        width: 100,
        render: (data, record) => <FormItem session={ record } type='checkbox'
                                            checked={ !!selectedSessions.some(x => x.sessionID === record.sessionID) }
                                            disabled={ !selectedSessions.some(x => x.sessionID === record.sessionID) && record.full }
                                            onChange={ handleSessionSelected } value={ record.session }
                                            form={ form }/>
    }, {
        title: 'Title',
        dataIndex: 'course.title',
        render: (data) => <div dangerouslySetInnerHTML={ { __html: data } }/>,
        key: 'title'
    }, {
        title: 'Target Audience',
        dataIndex: 'course.targetAudience',
        key: 'targetAudience'
    }, {
        title: 'Site',
        dataIndex: 'site',
        key: 'site'
    },
    {
        title: 'Capacity',
        dataIndex: 'capacity',
        width: 100,
        render: (data, record) => record.capacity > 0 ?
            <span>{ record.registered } / <strong>{ record.capacity }</strong></span> : <span>No Limit</span>,
        key: 'capacity'
    }
];

export const dateColumns = ({ selectedSessions, handleSessionSelected, form }) => [
    {
        title: 'Date',
        dataIndex: 'startTime',
        key: 'time',
        render: (data, record) =>
            <span>{ moment(record.startTime).format('MMMM Do, YYYY') }:<br/> { moment(record.startTime).format('LT') } - { moment(record.endTime).format('LT') }</span>
    }, {
        title: 'Select',
        key: 'select',
        width: 100,
        render: (data, record) => <FormItem session={ record } type='checkbox'
                                            checked={ !!selectedSessions.some(x => x.sessionID === record.sessionID) }
                                            disabled={ !selectedSessions.some(x => x.sessionID === record.sessionID) && record.full }
                                            onChange={ handleSessionSelected } value={ record.session }
                                            form={ form }/>
    }, {
        title: 'Title',
        dataIndex: 'course.title',
        render: (data) => <div dangerouslySetInnerHTML={ { __html: data } }/>,
        key: 'title'
    }, {
        title: 'Target Audience',
        dataIndex: 'course.targetAudience',
        key: 'targetAudience'
    },
    {
        title: 'Site',
        dataIndex: 'site',
        key: 'site'
    },
    {
        title: 'Capacity',
        dataIndex: 'capacity',
        width: 100,
        render: (data, record) => record.capacity > 0 ?
            <span>{ record.registered } / <strong>{ record.capacity }</strong></span> : <span>No Limit</span>,
        key: 'capacity'
    }
];